if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  const register = () => {
    Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          e.preventDefault();
          if (this.loading) return;

          let variantId = null;
          let lockAcquired = false;
          if (this.$refs.product_form) {
            variantId = new FormData(this.$refs.product_form).get('id');

            const storeSelector = window.Alpine?.store('xStoreSelector');
            if (storeSelector?.shouldBlockAtcForCurrentVariant?.(variantId)) {
              storeSelector.openOosSwitchPromptFromAtc(variantId);
              return;
            }

            if (!window.Eurus.atcInFlight) window.Eurus.atcInFlight = new Set();
            if (window.Eurus.atcInFlight.has(variantId)) return;
            window.Eurus.atcInFlight.add(variantId);
            lockAcquired = true;
          }

          this.loading = true;         

          setTimeout(async () => {
            const releaseLock = () => {
              if (lockAcquired && variantId) {
                window.Eurus.atcInFlight?.delete(variantId);
                lockAcquired = false;
              }
            };
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                releaseLock();
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            if (!this.$refs.product_form) {
              releaseLock();
              this.loading = false;
              return;
            }
            if (!variantId) {
              variantId = new FormData(this.$refs.product_form).get('id');
            }

            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            let resProductId;

            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {  
                resProductId = response.product_id;

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  await Alpine.store('xCartHelper').reRenderSections(response.sections);
                  const cartDrawer = document.getElementById('CartDrawer');
                  if (cartDrawer && typeof initAlpineMount === 'function') {
                    initAlpineMount(cartDrawer);
                  }
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart(true);
                  }
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              releaseLock();
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        }
      }));

    if (!Alpine.store('xCardCartQty')) {
    const cardQtyStore = {
      byVariant: {},
      revision: 0,
      loadingId: null,
      loadingDelta: 0,
      qty(variantId) {
        return this.byVariant[variantId] || this.byVariant[String(variantId)] || 0;
      },
      applyCart(cart) {
        const map = {};
        (cart.items || []).forEach((item) => {
          const total = (map[item.variant_id] || 0) + item.quantity;
          map[item.variant_id] = total;
          map[String(item.variant_id)] = total;
        });
        this.byVariant = map;
        this.revision += 1;
      },
      async refresh() {
        try {
          const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
          this.applyCart(cart);
        } catch (e) {}
      },
      delta(variantId, delta) {
        const next = this.qty(variantId) + delta;
        this.change(variantId, next, delta);
      },
      _linesForVariant(cart, variantId) {
        return (cart.items || []).filter(
          (item) => String(item.variant_id) === String(variantId)
        );
      },
      _updatesForTarget(lines, nextQty) {
        const updates = {};
        let remaining = nextQty;
        lines.forEach((item) => {
          if (remaining <= 0) {
            updates[item.key] = 0;
          } else if (item.quantity <= remaining) {
            updates[item.key] = item.quantity;
            remaining -= item.quantity;
          } else {
            updates[item.key] = remaining;
            remaining = 0;
          }
        });
        return updates;
      },
      _cartChangeFailed(data) {
        return !data || data.status === 422 || Boolean(data.errors);
      },
      async _postJson(url, payload) {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        return response.json();
      },
      async _requestWithSections(url, payload) {
        let data = await this._postJson(url, payload);
        if (this._cartChangeFailed(data) && payload.sections) {
          const { sections, sections_url, ...minimal } = payload;
          data = await this._postJson(url, minimal);
        }
        return data;
      },
      async change(variantId, nextQty, delta) {
        if (this.loadingId) return;
        const next = Math.max(0, parseInt(nextQty, 10) || 0);
        this.loadingDelta = delta || 0;
        this.loadingId = variantId;
        let response = null;
        try {
          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
          const lines = this._linesForVariant(cart, variantId);
          if (lines.length === 0) {
            return;
          }

          const sections = Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id);
          const sections_url = window.location.pathname;

          if (lines.length === 1) {
            const lineIndex = cart.items.findIndex((item) => item.key === lines[0].key) + 1;
            response = await this._requestWithSections(`${Shopify.routes.root}cart/change.js`, {
              line: lineIndex,
              quantity: next,
              sections,
              sections_url
            });
          } else {
            const updates = this._updatesForTarget(lines, next);
            response = await this._requestWithSections(`${Shopify.routes.root}cart/update.js`, {
              updates,
              sections,
              sections_url
            });
          }

          if (this._cartChangeFailed(response)) {
            throw new Error((response && response.message) || 'Cart update failed');
          }

          this.applyCart(response);
          if (response.sections) {
            await Alpine.store('xCartHelper').reRenderSections(response.sections);
          } else {
            await Alpine.store('xCartHelper').reRenderSections();
          }
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        } catch (e) {
          console.error('xCardCartQty.change:', e);
        } finally {
          window.updatingCart = false;
          this.loadingId = null;
          this.loadingDelta = 0;
          await this.refresh();
        }
      }
    };

    Alpine.store('xCardCartQty', cardQtyStore);
    Alpine.store('xCardCartQty').refresh();

    const scheduleCardQtyRefresh = () => {
      clearTimeout(window.__rathnaCardQtyRefreshTimer);
      window.__rathnaCardQtyRefreshTimer = setTimeout(() => {
        const store = Alpine.store('xCardCartQty');
        if (store && !store.loadingId) store.refresh();
      }, 80);
    };

    document.addEventListener('eurus:cart:items-changed', scheduleCardQtyRefresh);
    document.addEventListener('eurus:cart:redirect', scheduleCardQtyRefresh);

    const patchCartHelperForCardQty = () => {
      const cartHelper = Alpine.store('xCartHelper');
      if (!cartHelper || cartHelper.__rathnaCardQtyPatched) return;
      const originalReRender = cartHelper.reRenderSections.bind(cartHelper);
      cartHelper.reRenderSections = async (sections) => {
        const result = await originalReRender(sections);
        scheduleCardQtyRefresh();
        return result;
      };
      cartHelper.__rathnaCardQtyPatched = true;
    };
    patchCartHelperForCardQty();
    document.addEventListener('alpine:init', patchCartHelperForCardQty);
    }
  };

  if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }
}

(function () {
  if (window.rathnaCartSheetVersion >= 9) return;
  window.rathnaCartSheetVersion = 9;
  window.rathnaCartSheetBound = true;
  var pinning = false;
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sheetOffsetRaf = 0;

  function syncSheetOffset() {
    if (sheetOffsetRaf) cancelAnimationFrame(sheetOffsetRaf);
    sheetOffsetRaf = requestAnimationFrame(function () {
      sheetOffsetRaf = 0;
      var form = document.querySelector('main.theme-template-cart .form-checkout');
      if (!form || !mobileQuery.matches) {
        document.documentElement.style.removeProperty('--rathna-cart-sheet-offset');
        return;
      }
      var h = Math.ceil(form.getBoundingClientRect().height);
      if (h > 0) {
        document.documentElement.style.setProperty('--rathna-cart-sheet-offset', h + 'px');
      }
    });
  }

  function ensureExtrasPanel(extras) {
    if (!extras) return null;
    var panel = null;
    for (var i = 0; i < extras.children.length; i++) {
      if (extras.children[i].classList.contains('rathna-cart-extras__panel')) {
        panel = extras.children[i];
        break;
      }
    }
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'rathna-cart-extras__panel';
    while (extras.firstChild) panel.appendChild(extras.firstChild);
    extras.appendChild(panel);
    return panel;
  }

  function syncExtrasOpenClass(form, details) {
    if (!form || !details) return;
    // Keep open class while details[open], including during is-closing, so the sheet
    // stays expanded until the extras panel has finished collapsing.
    form.classList.toggle('is-extras-open', !!details.open);
  }

  function finishClose(details, form) {
    details.open = false;
    details.classList.remove('is-closing');
    details._rathnaAnimating = false;
    syncExtrasOpenClass(form, details);
    syncSheetOffset();
  }

  function animateExtrasClose(details, form) {
    if (!details.open || details._rathnaAnimating) return;
    if (reduceMotion.matches) {
      finishClose(details, form);
      return;
    }
    details._rathnaAnimating = true;
    details.classList.add('is-closing');
    syncExtrasOpenClass(form, details);
    syncSheetOffset();
    var extras = details.querySelector('.rathna-cart-extras');
    var done = false;
    var complete = function () {
      if (done) return;
      done = true;
      if (extras) extras.removeEventListener('transitionend', onEnd);
      window.clearTimeout(fallback);
      finishClose(details, form);
    };
    var onEnd = function (event) {
      if (event.target !== extras) return;
      if (event.propertyName !== 'grid-template-rows' && event.propertyName !== 'opacity') return;
      complete();
    };
    if (extras) extras.addEventListener('transitionend', onEnd);
    var fallback = window.setTimeout(complete, 450);
  }

  function animateExtrasOpen(details, form) {
    if (details.open || details._rathnaAnimating) return;
    details.classList.remove('is-closing');
    details.open = true;
    syncExtrasOpenClass(form, details);
    syncSheetOffset();
    if (reduceMotion.matches) return;
    var extras = details.querySelector('.rathna-cart-extras');
    if (!extras) return;
    // Force a reflow so the open transition always plays from 0fr.
    extras.style.gridTemplateRows = '0fr';
    extras.style.opacity = '0';
    void extras.offsetHeight;
    extras.style.gridTemplateRows = '';
    extras.style.opacity = '';
    window.setTimeout(syncSheetOffset, 420);
  }

  function ensureSheetChrome(form) {
    var handle = form.querySelector('.rathna-cart-sheet-handle');
    if (!handle) {
      handle = document.createElement('div');
      handle.className = 'rathna-cart-sheet-handle';
      handle.setAttribute('aria-hidden', 'true');
      handle.innerHTML = '<span></span>';
      form.insertBefore(handle, form.firstChild);
    }

    var details = form.querySelector('.rathna-cart-extras-details');
    var extras = form.querySelector('.rathna-cart-extras');
    var toggle = form.querySelector('.rathna-cart-extras-toggle');

    if (!extras) {
      var discountWrap = form.querySelector('#x-cart-discount-field');
      discountWrap = discountWrap && discountWrap.closest('.flex.justify-end.w-full');
      var noteWrap = form.querySelector('#x-cart-note');
      noteWrap = noteWrap && noteWrap.closest('.mb-5');
      if (discountWrap || noteWrap) {
        extras = document.createElement('div');
        extras.id = 'rathna-cart-extras';
        extras.className = 'rathna-cart-extras';
        var anchor = discountWrap || noteWrap;
        anchor.parentNode.insertBefore(extras, anchor);
        if (discountWrap) extras.appendChild(discountWrap);
        if (noteWrap) extras.appendChild(noteWrap);
      }
    }

    ensureExtrasPanel(extras);

    if (extras && !details) {
      details = document.createElement('details');
      details.className = 'rathna-cart-extras-details';
      extras.parentNode.insertBefore(details, extras);
      if (toggle && toggle.tagName === 'BUTTON') {
        var summary = document.createElement('summary');
        summary.className = 'rathna-cart-extras-toggle';
        summary.innerHTML = toggle.innerHTML;
        toggle.replaceWith(summary);
        toggle = summary;
      } else if (!toggle) {
        toggle = document.createElement('summary');
        toggle.className = 'rathna-cart-extras-toggle';
        toggle.innerHTML =
          '<span class="rathna-cart-extras-toggle__label">Discount &amp; order note</span>' +
          '<span class="rathna-cart-extras-toggle__chevron" aria-hidden="true"></span>';
      }
      details.appendChild(toggle);
      details.appendChild(extras);
    }

    if (details && !mobileQuery.matches) {
      details.classList.remove('is-closing');
      details.open = true;
      details._rathnaAnimating = false;
    }

    if (details && !details._rathnaWired) {
      details._rathnaWired = true;
      var summaryEl = details.querySelector('summary.rathna-cart-extras-toggle') || details.querySelector('summary');
      if (summaryEl) {
        summaryEl.addEventListener('click', function (event) {
          if (!mobileQuery.matches) return;
          event.preventDefault();
          if (details._rathnaAnimating) return;
          if (details.open && !details.classList.contains('is-closing')) {
            animateExtrasClose(details, form);
          } else if (!details.open) {
            animateExtrasOpen(details, form);
          }
        });
      }
      details.addEventListener('toggle', function () {
        if (details.classList.contains('is-closing')) return;
        syncExtrasOpenClass(form, details);
      });
    }

    var savings = form.querySelector('.rathna-cart-savings-line') || form.querySelector('#js-contents [role="status"]');
    if (savings && !savings.classList.contains('rathna-cart-savings-line')) {
      if (/saved|save/i.test(savings.textContent || '')) {
        savings.classList.add('rathna-cart-savings-line');
      }
    }

    return { handle: handle, details: details, toggle: toggle, extras: extras };
  }

  function pinMobileCheckout() {
    if (pinning) return;
    var form = document.querySelector('main.theme-template-cart .form-checkout');
    if (!form) return;
    pinning = true;
    try {
      var chrome = ensureSheetChrome(form);
      var state = form._rathnaSheet;
      if (!mobileQuery.matches) {
        form.classList.remove('is-extras-open');
        if (chrome.details) chrome.details.open = true;
        if (!state) return;
        if (state.totalMark.parentNode) state.totalMark.parentNode.insertBefore(state.total, state.totalMark);
        state.totalMark.remove();
        if (state.savings && state.savingsMark && state.savingsMark.parentNode) {
          state.savingsMark.parentNode.insertBefore(state.savings, state.savingsMark);
          state.savingsMark.remove();
        }
        if (state.buttonMark.parentNode) state.buttonMark.parentNode.insertBefore(state.button, state.buttonMark);
        state.buttonMark.remove();
        if (state.payments && state.paymentsMark && state.paymentsMark.parentNode) {
          state.paymentsMark.parentNode.insertBefore(state.payments, state.paymentsMark);
          state.paymentsMark.remove();
        } else if (state.payments && state.payments.parentNode === state.foot) {
          // Leave payments to be moved back with body children if mark is gone
          state.body.appendChild(state.payments);
        }
        while (state.body.firstChild) form.insertBefore(state.body.firstChild, state.body);
        state.body.remove();
        state.foot.remove();
        if (chrome.handle && chrome.handle.parentNode === form) form.insertBefore(chrome.handle, form.firstChild);
        if (chrome.details && chrome.details.parentNode) {
          form.insertBefore(chrome.details, form.firstChild === chrome.handle ? chrome.handle.nextSibling : form.firstChild);
        }
        delete form._rathnaSheet;
        return;
      }
      if (state && form.contains(state.foot)) {
        var pinnedSavings = form.querySelector('.rathna-cart-savings-line');
        if (pinnedSavings && !state.foot.contains(pinnedSavings)) {
          var checkoutBtn = state.foot.querySelector('#checkout-submit');
          if (checkoutBtn) state.foot.insertBefore(pinnedSavings, checkoutBtn);
          else state.foot.appendChild(pinnedSavings);
          state.savings = pinnedSavings;
        }
        var pinnedPayments = form.querySelector('.rathna-cart-payments-wrap');
        if (pinnedPayments && !state.foot.contains(pinnedPayments)) {
          state.foot.appendChild(pinnedPayments);
          state.payments = pinnedPayments;
        }
        if (chrome.handle && chrome.handle.parentNode !== form) {
          form.insertBefore(chrome.handle, form.firstChild);
        } else if (chrome.handle && form.firstChild !== chrome.handle) {
          form.insertBefore(chrome.handle, form.firstChild);
        }
        if (chrome.details) {
          var detailsTarget = state.body || form.lastChild;
          if (chrome.details.parentNode !== form || chrome.details.nextSibling !== detailsTarget) {
            var wasOpen = chrome.details.open;
            form.insertBefore(chrome.details, detailsTarget);
            chrome.details.open = wasOpen;
          }
        } else if (chrome.toggle && chrome.toggle.parentNode !== form) {
          form.insertBefore(chrome.toggle, state.body || form.lastChild);
        }
        form.classList.toggle('is-extras-open', !!(chrome.details && chrome.details.open));
        return;
      }
      var total = form.querySelector('.rathna-cart-total-line') || form.querySelector('#js-contents .flex:has(> p.h4)');
      var savings = form.querySelector('.rathna-cart-savings-line');
      var button = form.querySelector('#checkout-submit');
      var payments = form.querySelector('.rathna-cart-payments-wrap');
      if (!total || !button) return;
      total.classList.add('rathna-cart-total-line');
      var totalMark = document.createComment('rathna-total');
      var buttonMark = document.createComment('rathna-checkout');
      var savingsMark = null;
      var paymentsMark = null;
      total.parentNode.insertBefore(totalMark, total);
      if (savings) {
        savingsMark = document.createComment('rathna-savings');
        savings.parentNode.insertBefore(savingsMark, savings);
      }
      button.parentNode.insertBefore(buttonMark, button);
      if (payments) {
        paymentsMark = document.createComment('rathna-payments');
        payments.parentNode.insertBefore(paymentsMark, payments);
      }
      var body = document.createElement('div');
      body.className = 'rathna-cart-sheet-body';
      var foot = document.createElement('div');
      foot.className = 'rathna-cart-sheet-foot';
      var handle = chrome.handle;
      var details = chrome.details;
      while (form.firstChild) body.appendChild(form.firstChild);
      if (handle) form.appendChild(handle);
      if (details) form.appendChild(details);
      foot.appendChild(total);
      if (savings) foot.appendChild(savings);
      foot.appendChild(button);
      if (payments) foot.appendChild(payments);
      form.appendChild(body);
      form.appendChild(foot);
      form._rathnaSheet = {
        body: body,
        foot: foot,
        total: total,
        savings: savings,
        button: button,
        payments: payments,
        totalMark: totalMark,
        savingsMark: savingsMark,
        buttonMark: buttonMark,
        paymentsMark: paymentsMark
      };
    } finally {
      pinning = false;
      syncSheetOffset();
    }
  }

  function boot() {
    var cartRoot = document.getElementById('main-cart-items');
    if (cartRoot && window.MutationObserver && !cartRoot._rathnaSheetObserver) {
      var queued = false;
      var observer = new MutationObserver(function (mutations) {
        if (queued || pinning) return;
        var relevant = mutations.some(function (m) {
          var t = m.target;
          if (!t || !t.closest) return true;
          if (t.closest('.rathna-cart-extras-details') || t.closest('.rathna-cart-sheet-foot')) return false;
          return true;
        });
        if (!relevant) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          pinMobileCheckout();
        });
      });
      observer.observe(cartRoot, { childList: true, subtree: true });
      cartRoot._rathnaSheetObserver = observer;
    }
    pinMobileCheckout();
    syncSheetOffset();
    if (window.ResizeObserver && !window._rathnaCartSheetResizeObs) {
      var resizeObs = new ResizeObserver(function () {
        syncSheetOffset();
      });
      var watchForm = function () {
        var form = document.querySelector('main.theme-template-cart .form-checkout');
        if (form && form !== window._rathnaCartSheetResizeTarget) {
          if (window._rathnaCartSheetResizeTarget) resizeObs.unobserve(window._rathnaCartSheetResizeTarget);
          resizeObs.observe(form);
          window._rathnaCartSheetResizeTarget = form;
        }
      };
      watchForm();
      window._rathnaCartSheetResizeObs = resizeObs;
      window._rathnaCartSheetWatchForm = watchForm;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.main-product .shopify-payment-button__button--unbranded')
      : null;
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
  }, true);
  window.addEventListener('resize', function () {
    pinMobileCheckout();
    syncSheetOffset();
    if (window._rathnaCartSheetWatchForm) window._rathnaCartSheetWatchForm();
  });
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', pinMobileCheckout);
})();
